import { render, staticRenderFns } from "./ProjectAddDoctor.vue?vue&type=template&id=21aad47e"
import script from "./ProjectAddDoctor.vue?vue&type=script&lang=js"
export * from "./ProjectAddDoctor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports